"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaperSizeLETTER = void 0;
exports.PaperSizeLETTER = {
    LETTER: 'LETTER'
};
//# sourceMappingURL=paper-size-letter.js.map